import { useIntl } from 'react-intl';
import RoiPreviewPane, {
    RoiPreviewPaneProps,
} from '~/containers/viewer/viewport/RoiPreviewPane';
import FittedPane from './FittedPane';

type FittedRoiPreviewPaneProps = Omit<RoiPreviewPaneProps, 'sizePx'>;

/**
 * The 3D structure preview fitted to its box: the square scene takes the
 * box's shorter side and sits in the middle; nothing is drawn while the
 * box has no extent. The hover hint says how to orbit, spin and zoom, and,
 * while an uncommitted shape is drawn, that the shape is not part of the
 * structure.
 */
export default function FittedRoiPreviewPane(props: FittedRoiPreviewPaneProps) {
    const intl = useIntl();
    return (
        <FittedPane
            hint={intl.formatMessage({
                id: props.uncommittedVolume
                    ? 'structure.preview3D.tooltipUncommitted'
                    : 'structure.preview3D.tooltip',
            })}
            testId="fitted-roi-preview-pane"
        >
            {(box) => {
                const sizePx = Math.floor(Math.min(box.widthPx, box.heightPx));
                if (sizePx <= 0) {
                    return null;
                }
                return <RoiPreviewPane {...props} sizePx={sizePx} />;
            }}
        </FittedPane>
    );
}
